/* eslint-disable react-hooks/exhaustive-deps */
import ResourceHelmet from "../components/ResourceHelmet";
import { RESOURCE_MODULE_TITLES } from "../utils/constants";
import ToastMessage from "components/ToastMessage/ToastMessage";
import Preloader from "components/Preloader/Preloader";
import useLoadingRequest from "components/Preloader/utils/hooks/useLoadingRequest";
import BackToView from "components/BackToView/BackToView";
import ABSOLUTE_PATHS from "routes/utils/absolutePaths";
import UniversitySpaceHeader from "./UniversitySpaceHeader";
import useDashboardContext from "routes/utils/context/useDashboardContext";
import { USER_ROLES } from "config/userPermissions";
import useFilters from "./UniversitySpaceFilters/utils/hooks/useFilters";
import useDataRelatedToUniversitySpaceResources from "./utils/hooks/useDataRelatedToUniversitySpaceResources";
import usePaginator from "components/Paginator/utils/hooks/usePaginator";
import useSpaceList from "./utils/hooks/useSpaceList";
import useShowDialogAlert from "components/DialogAlert/utils/hooks/useDialogAlert";
import RegisterSpaceForm from "./Forms/RegisterSpaceForm";
import useToastMessage from "components/ToastMessage/utils/hooks/useToastMessage";
import SchedulesWrapper from "./SchedulesWrapper/SchedulesWrapper";
import DialogNonBusinessDay from "./Dialogs/DialogNonBusinessDay";
import UniversitySpaceGuideMessage from "./UniversitySpaceGuideMessage";
import useSpaceSelected from "../../Configuracion/SettingsSpaceAdmin/utils/hooks/useSpaceSelected";
import useNonBusinessDay from "./Dialogs/DialogNonBusinessDay/hooks/useNonBusinessDay";
import ResourcesUniversitySpacesContext from "./utils/context/ResourcesUniversitySpacesContext";
import useFatalError from "utils/hooks/useFatalError";

const ResourcesUniversitySpaces = () => {
    const toastMessage = useToastMessage();
    const { id: userRole } = useDashboardContext().user.role;
    const isCampusCoordinator = userRole === USER_ROLES.RECURSOS_ESPACIOS_UNIVERSITARIOS_COORDINADOR_CAMPUS || userRole === USER_ROLES.COORDINADOR_EVENTOS_ESPACIOS_UNIVERSITARIOS;
    const fatalError = useFatalError();
    const loadingRequestOfGrid = useLoadingRequest();
    const loadingRequestOfReservationAction = useLoadingRequest();
    const dialogSpaceForm = useShowDialogAlert();
    const filters = useFilters({ isCampusCoordinator });
    const paginator = usePaginator();
    const data = useDataRelatedToUniversitySpaceResources({ loadingRequestOfGrid, fatalError });
    const nonBusinessDay = useNonBusinessDay({
        appliedFilters: filters.appliedFilters
    });
    const spaceList = useSpaceList({
        utils: {
            toastMessage,
            loadingRequestOfGrid
        },
        fatalError,
        filters,
        paginator,
        isCampusCoordinator
    });
    const spaceSelected = useSpaceSelected();
    //#endregion
    //#region Effects
    //#endregion
    //#region Functions
    function resetUI() {
        filters.clear();
        spaceList.clear();
        paginator.clear();
    }
    function openShowDialogSpaceForm({ space }) {
        spaceSelected.update(space);
        dialogSpaceForm.set(true);
    }
    //#endregion
    const allFilterFieldsWereFilled = filters.areCompleted();
    if (fatalError.value) return null;
    return (
        <ResourcesUniversitySpacesContext.Provider value={{
            loadingRequestOfReservationAction,
            toastMessage, spaceList
        }}>
            <ResourceHelmet title={RESOURCE_MODULE_TITLES.UNIVERSITY_SPACES} />
            <Preloader {...loadingRequestOfGrid.value} />
            <Preloader {...loadingRequestOfReservationAction.value} />
            <ToastMessage {...toastMessage.value} />
            <BackToView
                to={ABSOLUTE_PATHS.RESOURCES}
                text="Volver a Inicio" />
            <UniversitySpaceHeader
                isCampusCoordinator={isCampusCoordinator}
                filters={filters}
                data={data}
                paginator={paginator}
                resetUI={resetUI}
                loadingRequest={loadingRequestOfGrid}
                allFilterFieldsWereFilled={allFilterFieldsWereFilled} />
            {spaceList.value
                ? <SchedulesWrapper
                    data={data} 
                    openShowDialogSpaceForm={openShowDialogSpaceForm}
                    isLoading={!loadingRequestOfGrid.value.hidden}
                    appliedFilters={filters.appliedFilters}
                    openDialogNonBusinessDay={nonBusinessDay.openDialog}/>
                : <UniversitySpaceGuideMessage />}
            <RegisterSpaceForm
                data={data}
                dialog={dialogSpaceForm}
                isCampusCoordinator={isCampusCoordinator}
                preselectedData={{
                    campusId: filters.value.campusId
                }}
                dialogSpaceForm={dialogSpaceForm}
                spaceSelected={spaceSelected}
                spaceList={spaceList}
                filtersAreCompleted={filters.areCompleted} />
            <DialogNonBusinessDay {...nonBusinessDay}/>
        </ResourcesUniversitySpacesContext.Provider>
    );
}

export default ResourcesUniversitySpaces;